import Languages from 'ha/constants/Languages';

export default ({ params: { lang = '' } }) =>
  Object.keys(Languages).includes(lang.toLowerCase());
